export default "__VITE_ASSET__ZkBgg1bV__"